import { shaderMaterial, useTexture } from '@react-three/drei'
import { extend, useFrame } from '@react-three/fiber'
import React, { useRef } from 'react'
import vertex from '../shaders/vertex.glsl'
import fragment from '../shaders/fragment.glsl'
import { Vector2, Color, RepeatWrapping, LinearFilter, SRGBColorSpace } from 'three'

export default function BaseMaterial( {
    texture ='./textures/noise/noiseVoronoi.webp',
    ...props
} ) 
{
    const self = useRef()

    const noise = useTexture( texture )
    noise.wrapS = RepeatWrapping
    noise.wrapT = RepeatWrapping
    noise.magFilter = LinearFilter
    noise.minFilter = LinearFilter

    const gradientMap = useTexture( './textures/gradientmaps/gradientMapN.png' )
    gradientMap.colorSpace = SRGBColorSpace

    const noise2 = useTexture( './textures/noise/noise.png' )
    noise2.wrapS = RepeatWrapping
    noise2.wrapT = RepeatWrapping
    noise2.magFilter = LinearFilter
    noise2.minFilter = LinearFilter

    const noise3 = useTexture( './textures/noise/noisePerlin.webp' )
    noise3.wrapS = RepeatWrapping
    noise3.wrapT = RepeatWrapping
    noise3.magFilter = LinearFilter
    noise3.minFilter = LinearFilter

    const uniforms =
    {
        uTime: 0,
        uNoiseTexture: noise,
        uNoise2Texture: noise2,
        uNoise3Texture: noise3,
        uColorMap: gradientMap,
        uColorSparks: new Color('#AFFBDE'),
    }

    useFrame( ( state, delta ) =>
    {
        self.current.uniforms.uTime.value += delta
    })

    const BaseMaterial = shaderMaterial( uniforms, vertex, fragment )
    extend( { BaseMaterial } )

    return (
        <baseMaterial
            key={ BaseMaterial.key }
            ref={ self }
            {...props}
        />
    )
}